/* eslint-disable import/order */
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { classicBusinessProformaIssueFormsDirectEmbedRoute } from '@jira/router-routes__proforma-routes/src/classicBusinessProformaIssueFormsDirectEmbedRoute.tsx';
import ProformaIssueFormsDirectEmbed, {
	LazyProformaIssueFormsDirectEmbed,
} from './ui/issue-forms-direct/embed/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const classicBusinessProformaIssueFormsDirectEmbedRouteEntry: Route = createEntry(
	classicBusinessProformaIssueFormsDirectEmbedRoute,
	() => ({
		group: 'classic-business',
		layout: chromelessLayout,
		resources: [...jiraSpaResources(), projectContextResource],
		// eslint-disable-next-line no-restricted-syntax
		component: ProformaIssueFormsDirectEmbed,
		forPaint: [LazyProformaIssueFormsDirectEmbed],
		perfMetricKey: 'issue-forms-direct-embed',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
